<template>
  <div class="header-container">
    <div class="header" v-for="header in headers" :key="header.label" :style="{ width: header.width }">
      <span class="header-label">{{ header.label }}</span>
      <span
        v-if="header.value === 'type'"
        class="header-value"
      >
        {{ objectType }}
      </span>
      <span
        v-else-if="header.value === 'nrCables'"
        class="header-value"
        style="text-align: right;"
      >
        {{ nrCables }}
      </span>
      <span
        v-else-if="header.value === 'nrTubes'"
        class="header-value"
        style="text-align: right;"
      >
        {{ nrTubes }}
      </span>
      <span
        v-else-if="header.value === 'material'"
        class="header-value"
      >
        {{ objectPrefix === 'mb' ? objectMaterialDescription : '-'}}
      </span>
      <span
        v-else-if="objectPrefix === 'mb'"
        class="header-value"
      >
        {{ conductData.microducts_bundles[0][objectPrefix + '_' + header.value] ? conductData.microducts_bundles[0][objectPrefix + '_' + header.value] : '-' }}
      </span>
      <span
        v-else
        class="header-value"
      >
        {{ conductData[objectPrefix + '_' + header.value] ? conductData[objectPrefix + '_' + header.value] : '-' }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "MicroDuctPanelHeader",

  props: {
    conductData: {
      type: Object,
      required: true
    },

    microDuctsList: {
      type: Array
    }
  },

  computed: {
    objectPrefix() {
      return this.objectIsBundle ? 'mb' : 'cd'
    },

    objectType() {
      return this.objectIsBundle ? this.$i18n.tc("Bundle", 1) : this.$i18n.tc("Conduct", 1);
    },

    objectIsBundle() {
      return !!this.conductData.microducts_bundles;
    },

    objectMaterialDescription() {
      let description = null;
      if (this.objectIsBundle) {
        let microDuct = this.microDuctsList.find(microDuct => microDuct.sm_id === this.conductData.microducts_bundles[0].mb_material_id);
        description = microDuct ? microDuct.sm_description : null
      }
      return description;
    },

    nrCables() {
      let nrCables = 0;
      if (this.objectIsBundle) {
        this.conductData.microducts_bundles[0].microducts.forEach(microduct => {
          if (microduct.cables) {
            nrCables += microduct.cables.length
          }
        });
      } else {
        nrCables = this.conductData.cables.length;
      }
      return nrCables;
    },

    nrTubes() {
      let nrTubes = null;
      if (this.objectIsBundle) {
        let microDuct = this.microDuctsList.find(microDuct => microDuct.sm_id === this.conductData.microducts_bundles[0].mb_material_id);
        nrTubes = microDuct ? this.nrCables + '/' + microDuct.family_specific_fields.smud_microduct_count : null;
      } else {
        nrTubes = this.conductData.cables.length + '/' + this.conductData.cables.length;
      }
      return nrTubes;
    },

    headers() {
      return [
        {
          label: this.$i18n.tc("Label", 1),
          value: 'label',
          width: '35%'
        },
        {
          label: this.$i18n.tc("Type", 1),
          value: 'type',
          width: '15%'
        },
        {
          label: this.$i18n.tc("Material", 1),
          value: 'material',
          width: '25%'
        },
        // {
        //   label: this.$i18n.tc("Owner", 1)
        // },
        {
          label: this.$i18n.t("NrTubes"),
          value: 'nrTubes'
        },
        {
          label: this.$i18n.t("NrCables"),
          value: 'nrCables'
        }
      ]
    }
  }
}
</script>

<style scoped>
.header-container {
  display: flex;
  justify-content: flex-start;
}

.header {
  display: flex;
  flex-direction: column;
  margin-right: 15px;
}

.header-label {
  font-size: 10px;
  color: #bebebe;
  margin-bottom: 2px;
}

.header-value {
  font-weight: 600;
}
</style>


// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Pathways/MicroDuctPanelHeader.vue